module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Medium-bc55ab5b570bec95e21faae0660c9397.woff";